export default __webpack_public_path__ + "static/media/Animals20.27a9e336.jpg";